import { useProduct } from '@ecomm/data-products'
import { overloadMaybe } from '@simplisafe/ewok'
import * as O from 'fp-ts/lib/Option'
import { pipe } from 'fp-ts/lib/function'

export const useEcommerceProduct = (sku: string) => {
  const selectedProduct = useProduct(sku)

  return pipe(
    overloadMaybe(selectedProduct.toMaybe()),
    O.fold(
      () => {
        return {
          isOnStock: true,
          isSellable: true,
          restockDate: '',
          type: ''
        }
      },
      prod => {
        return {
          isOnStock: prod.isOnStock,
          isSellable: prod.isSellable,
          restockDate: prod.restockDate || '',
          type: prod.productType
        }
      }
    )
  )
}
